<template>
  <v-snackbar
    v-if="message && !disableMessages"
    :color="messageColor"
    :timeout="messageTimeout"
    top
    v-model="message"
  >
    {{ messageText }}
    <v-btn
      flat
      @click.native="closeMessage"
      v-if="showCloseButton"
    >
      {{ $t('general.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      showCloseButton: false,
      messageTimeout: 1800,
      messageColor: '',
      messageText: ''
    }
  },
  methods: {
    closeMessage () {
      this.$store.commit('showMessage', {
        type: 'info',
        message: null,
        timeout: null,
        show: false,
        color: null,
        showCloseButton: false
      })
    }
  },
  mounted () {},
  computed: {
    ...mapGetters([
      'storeMessages',
      'storeSettings'
    ]),
    disableMessages: {
      get () {
        return this.storeSettings.disableMessages || false
      }
    },
    message: {
      get: function () {
        if (this.storeMessages.type === 'success') {
          this.messageColor = 'success'
          this.messageText = this.$t('ademe.hint.successSaveBody')
        } else if (this.storeMessages.type === 'error') {
          this.messageColor = 'error'
          this.messageText = this.$t('account.activation.error')
        } else if (this.storeMessages.type === 'info') {
          this.messageColor = 'info'
          this.messageText = this.$t('general.information')
        }

        this.showCloseButton = this.storeMessages.showCloseButton

        if (this.storeMessages.color && this.storeMessages.color !== '') {
          this.messageColor = this.storeMessages.color
        }

        if (this.storeMessages.message && this.storeMessages.message !== '') {
          this.messageText = this.storeMessages.message
        }

        if (this.storeMessages.timeout && this.storeMessages.timeout !== '') {
          this.messageTimeout = this.storeMessages.timeout
        }

        return this.storeMessages.show
      },
      set: function () {
        this.closeMessage()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/client/components/Navigation/Messages.vue